import React, { useState, useEffect } from "react";
import CommonTable from "../../components/commonComponent/CommanTable";
import CommonModalForm from "../../components/commonComponent/CommonModalForm";
import { FaPencilAlt } from "react-icons/fa";

function GeneralSetting() {
  const [activeTab, setActiveTab] = useState("setting");
  const [searchTerm, setSearchTerm] = useState("");
  const [settings, setSettings] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({ name: "", key: "" });
  const [selectedRow, setSelectedRow] = useState(null);
  const [emailFormValues, setEmailFormValues] = useState({
    mailForName: "",
    mailForEmail: "",
    mailHost: "",
    mailPort: "",
    mailEncryption: "",
    mailUsername: "",
    mailPassword: "",
  });

  useEffect(() => {
    setSettings([
      { id: 1, key: "default_currency", value: "₹ Default Currency" },
      { id: 2, key: "lead_prefix", value: "INNO" },
      { id: 3, key: "site_name", value: "Innoveza Business Software Solutions" },
    ]);
  }, []);

  const columns = [
    { key: "srNo", label: "Sr.no" },
    { key: "key", label: "Key" },
    { key: "value", label: "Value" },
    { key: "actions", label: "Action" },
  ];

  const data = settings
    .filter(
      (s) =>
        s.key.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.value.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .map((s, i) => ({
      ...s,
      srNo: i + 1,
      actions: (
        <button
          className="btn btn-sm shadow-none border-0 text-primary"
          title="Edit"
          onClick={() => handleEdit(s)}
        >
          <FaPencilAlt size={14} />
        </button>
      ),
    }));

  const handleEdit = (row) => {
    setSelectedRow(row);
    setFormValues({ name: row.key, key: row.value });
    setShowModal(true);
  };

  const handleSubmit = () => {
    if (!formValues.name || !formValues.key) {
      alert("Please fill all required fields!");
      return;
    }

    const updatedList = settings.map((item) =>
      item.id === selectedRow.id
        ? { ...item, key: formValues.name, value: formValues.key }
        : item
    );

    setSettings(updatedList);
    setShowModal(false);
    alert("Setting updated successfully!");
  };

  const fields = [
    { name: "name", label: "Name", type: "text", placeholder: "Enter name" },
    {
      name: "key",
      label: "Key",
      type: "select",
      placeholder: "Select Currency",
      options: [
        { label: "₹ Default Currency", value: "₹ Default Currency" },
        { label: "$ Dollar", value: "$ Dollar" },
        { label: "€ Euro", value: "€ Euro" },
        { label: "¥ Yen", value: "¥ Yen" },
      ],
    },
  ];

  const handleEmailSubmit = () => {
    alert("Email settings saved successfully!");
    console.log("Email Settings:", emailFormValues);
  };

  return (
    <div className="container-fluid mt-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
        <h2 className="h2 mb-0 text-dark">General Setting</h2>
      </div>

      {/* Search Bar */}
      {activeTab === "setting" && (
        <div className="d-flex justify-content-end mb-3">
          <div className="input-group" style={{ maxWidth: 250 }}>
            <span className="input-group-text bg-white border-end-0 mt-2">
              <i className="fas fa-search text-muted"></i>
            </span>
            <input
              type="text"
              className="form-control border-start-0 mt-2"
              placeholder="Type to search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ boxShadow: "none" }}
            />
          </div>
        </div>
      )}

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3 gap-1">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "setting" ? "active" : ""}`}
            onClick={() => setActiveTab("setting")}
            style={{
              backgroundColor: activeTab === "setting" ? "#24336E" : "",
              color: activeTab === "setting" ? "#ffffff" : "#212529",
              border: activeTab === "setting" ? "1px solid #24336E" : "",
              borderRadius: "4px",
            }}
          >
            Setting
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "email" ? "active" : ""}`}
            onClick={() => setActiveTab("email")}
            style={{
              backgroundColor: activeTab === "email" ? "#24336E" : "",
              color: activeTab === "email" ? "#ffffff" : "#212529",
              border: activeTab === "email" ? "1px solid #24336E" : "",
              borderRadius: "4px",
            }}
          >
            Email
          </button>
        </li>
      </ul>

      {/* Conditional Render */}
      {activeTab === "setting" ? (
        <CommonTable
          columns={columns}
          data={data}
          itemsPerPageOptions={[10, 15, 25, 50]}
          defaultItemsPerPage={15}
        />
      ) : (
        <div className="d-flex justify-content-center">
          <div className="card shadow-sm border-0 rounded-4 p-4 w-100" style={{ maxWidth: "1200px" }}>
            <form
              className="rounded-4 p-4"
              style={{ background: "#fafbfc", border: "2.5px solid #c7dbed" }}
            >

              <div className="container" style={{ maxWidth: "900px" }}>
                <div className="row g-3">
                  {/* Mail For Name */}
                  <div className="col-md-4">
                    <label className="form-label text-muted mb-1">Mail For Name</label>
                    <input
                      type="text"
                      className="form-control form-control-sm rounded-3"
                      placeholder="Abacc2005"
                      style={{ height: "34px" }}
                    />
                  </div>

                  {/* Mail For Email */}
                  <div className="col-md-4">
                    <label className="form-label text-muted mb-1">Mail For Email</label>
                    <input
                      type="email"
                      className="form-control form-control-sm rounded-3"
                      placeholder="youremail@gmail.com"
                      style={{ height: "34px" }}
                    />
                  </div>

                  {/* Mail Host */}
                  <div className="col-md-4">
                    <label className="form-label text-muted mb-1">Mail Host</label>
                    <select
                      className="form-select form-select-sm rounded-3"
                      style={{ height: "34px" }}
                    >
                      <option>smtp.example.com</option>
                      <option>smtp.gmail.com</option>
                    </select>
                  </div>

                  {/* Mail Port */}
                  <div className="col-md-4">
                    <label className="form-label text-muted mb-1">Mail Port</label>
                    <input
                      type="number"
                      className="form-control form-control-sm rounded-3"
                      placeholder="587"
                      style={{ height: "34px" }}
                    />
                  </div>

                  {/* Mail Encryption */}
                  <div className="col-md-4">
                    <label className="form-label text-muted mb-1">Mail Encryption</label>
                    <select
                      className="form-select form-select-sm rounded-3"
                      style={{ height: "34px" }}
                    >
                      <option>TLS</option>
                      <option>SSL</option>
                    </select>
                  </div>

                  {/* Mail Username */}
                  <div className="col-md-4">
                    <label className="form-label text-muted mb-1">Mail Username</label>
                    <input
                      type="text"
                      className="form-control form-control-sm rounded-3"
                      placeholder="Your Username"
                      style={{ height: "34px" }}
                    />
                  </div>

                  {/* Mail Password */}
                  <div className="col-md-4 offset-md-0">
                    <label className="form-label text-muted mb-1">Mail Password</label>
                    <input
                      type="password"
                      className="form-control form-control-sm rounded-3"
                      placeholder="Your Password"
                      style={{ height: "34px" }}
                    />
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-center gap-3 mt-4">
                <button
                  type="button"
                  className="btn btn-outline-secondary px-4 rounded-3"
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn text-white px-4 rounded-3"
                  style={{ background: "#24336E" }}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>

      )}

      {/* Edit Modal */}
      <CommonModalForm
        visible={showModal}
        title="Edit General Setting"
        fields={fields}
        values={formValues}
        onChange={setFormValues}
        onCancel={() => setShowModal(false)}
        onSubmit={handleSubmit}
        submitLabel="Save"
        cancelLabel="Cancel"
        requiredFields={["name", "key"]}
      />
    </div>
  );
}

export default GeneralSetting;
